import { type GameState, type Pos, posEqual } from './types.js';

export function isPathComplete(
  path: Pos[] | undefined,
  endpoints: [Pos, Pos],
): boolean {
  if (!path || path.length < 2) return false;
  const first = path[0];
  const last = path[path.length - 1];
  const [a, b] = endpoints;
  return (
    (posEqual(first, a) && posEqual(last, b)) ||
    (posEqual(first, b) && posEqual(last, a))
  );
}

export function isWin(state: GameState, requireFullGrid = true): boolean {
  for (const [color, endpoints] of state.endpoints) {
    const path = state.paths.get(color);
    if (!isPathComplete(path, endpoints)) return false;
  }

  if (!requireFullGrid) return true;

  return state.grid.every((row) => row.every((cell) => cell !== null));
}
